import hero from "../../assets/images/LX/hero.webp";
import logo from "../../assets/images/LX/logo.webp";
import mvp from "../../assets/images/LX/mvp.webp";

const loyalxProjectData = {
  id: "4",
  title: "Branding, MVP App Design & Investor Pitch for LoyalX Fintech Super App",
  subtitle:
    "A complete brand system, research-driven MVP app design, and two investor pitch decks (including a 100-page master deck) that supported multiple VC meetings for a fintech super app startup.",
  client: "LoyalX",
  year: "2022",
  role: "Brand Strategist · Product Designer · MVP Architect · Pitch Deck Designer",
  heroImage: hero,
  skills: [
    "Brand Identity Design",
    "Product Strategy",
    "Fintech UX/UI",
    "MVP App Design",
    "Pitch Deck Development",
  ],
  link: null,

  sections: [
    {
      title: "Brand Strategy & Identity",
      body:
        "• Defined **Brand Positioning** for LoyalX as a unified **Fintech Super App** combining rewards, payments, and merchant ecosystems.\n\n" +
        "• Designed a modern and trust-focused **Brand Identity System** built for scalability.\n\n" +
        "• Created logo and complete **Brand Guidelines**.\n\n" +
        "• Built a consistent **Design System** for app UI, marketing assets, and investor materials.\n\n" +
        "• Positioned LoyalX as a future-ready **Loyalty Infrastructure Platform**.",
      image: logo,
    },

    {
      title: "Research-Driven MVP & Investor Pitch",
      body:
        "• Conducted detailed **Market Research** to define product direction.\n\n" +
        "• Designed the complete **MVP Architecture** with all core user flows including onboarding, wallet, rewards tracking, redemption, merchant discovery, and transactions.\n\n" +
        "• Structured scalable **UX Flows** ready for future product expansion.\n\n" +
        "• Created high-fidelity **Mobile App Mockups** covering the full product experience.\n\n" +
        "• Developed two **Investor Pitch Decks**, including a detailed 100-page master deck.\n\n" +
        "• The decks led to multiple **VC Meetings** and strong funding discussions.",
      image: mvp,
    },
  ],
};

export default loyalxProjectData;